import { Bar } from "./components/bar/bar";
import { Base } from "./progressBar.base";

export const ProgressBar = Object.assign(Base, {
    Bar: Bar
});
